module.exports = __webpack_public_path__ + "img/tab-select-bg-DCl8rbkb.f720c82e.png";